<script>
    export let title;
    export let subtitle;
    export let massive;
    export let large;
    export let emojiUrl;
    export let position = "center";
</script>

<style lang="scss">
    @import "../../styles/_mixins.scss";

    h1 {
        font-weight: var(--weight-medium);
        font-size: var(--font-large);
        text-align: center;
        position: relative;
        max-width: var(--max-width-content);
        margin: 0 auto;
        margin-bottom: var(--spacer-tiny);

        @include sm {
            font-size: var(--font-huge);
            text-align: var(--text-position);
        }

        &:after {
            position: absolute;
            display: inline-block;
            content: var(--emojiUrl);
            width: 50px;
            bottom: 0;
            filter: drop-shadow(0px 3px 4px rgba(0, 0, 0, 0.15));
            user-select: none;
            margin-left: var(--spacer-small);
            animation-name: wave-animation;
            animation-duration: "2.5s";
            transform-origin: 70% 70%;
            transition: transform 1000ms ease-in-out;
        }
    }

    p {
        font-size: var(--font-regular);
        text-align: center;

        @include sm {
            font-size: var(--font-large);
            text-align: var(--text-position);
        }
    }

    .massive {
        font-size: var(--font-large);
        font-weight: var(--weight-bold);
        margin-bottom: var(--spacer-tiny);

        @include sm {
            font-size: var(--font-xmassive);
        }
    }

    .large {
        font-size: var(--font-large);
        margin-bottom: var(--spacer-tiny);

        @include sm {
            font-size: var(--font-massive);
        }
    }

    @keyframes wave-animation {
        0% {
            transform: rotate(0deg);
        }
        10% {
            transform: rotate(14deg);
        }
        20% {
            transform: rotate(-8deg);
        }
        30% {
            transform: rotate(14deg);
        }
        40% {
            transform: rotate(-4deg);
        }
        50% {
            transform: rotate(10deg);
        }
        60% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(0deg);
        }
    }
</style>

<header>
    {#if emojiUrl}
        <h1
            class:massive
            class:large
            style="--text-position:{position}; --emojiUrl:url({emojiUrl})">
            {title}
        </h1>
    {:else}
        <h1 class:massive class:large style="--text-position:{position}">
            {@html title}
        </h1>
    {/if}

    {#if subtitle}
        <p style="--text-position:{position}">{subtitle}</p>
    {/if}
</header>
